import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=a0b75c1c&scoped=true&"
import script from "./MessageCell.vue?vue&type=script&lang=js&"
export * from "./MessageCell.vue?vue&type=script&lang=js&"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=a0b75c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b75c1c",
  null
  
)

component.options.__file = "MessageCell.vue"
export default component.exports